module.exports = __webpack_public_path__ + "assets/BngMUXZYTXPIvIBgJJSb6ufN5qU-810466.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/BngMUXZYTXPIvIBgJJSb6ufN5qU.woff2
// module id = 873
// module chunks = 2